module.exports = __webpack_public_path__ + "img/man_movement_trainig.dc44b69b.jpg";